export default "__VITE_ASSET__79264dc1__"